ACC.global = {

    _autoload: [
        ["passwordStrength", $('.password-strength').length > 0],
        "bindToggleOffcanvas",
        "closeMenuOnClickOut",
        "bindToggleXsSearch",
        "disableBtnOnclick",
        "bindHoverIntentMainNavigation",
        "initImager",
        "backToHome",
        "toggleCheckbox",
        "myaccountWysDeleteEmptyP",
        "testCheck",
        "viewHomePageBanner",
        "clickHomePageBanner",
        "myaccountContactBtnTel",
        "myaccountContactBtnEmail",
        "openCompletionPopin",
		"openRgpdRequestPopin",
        "openLoyaltyUnsubscribePopin",
        "viewHomePageBanner",
		"showIfConnected",
        "submitFormsGA",
        ["alterPassInfo", $('.pass-info').length > 0],
        "selectAganecyEvent",
        "trackPlpClick",
        "historyBackBtn",
        ["mySelect", $('.mySelect').length > 0],
    ],

    historyBackBtn: function() {
        $(document).on("click",".js-back-action",function(e){
            e.preventDefault();
            history.back();
        });
    },

    disableBtnOnclick: function(){
        $(document).on("click", ".mini-cart-body .mini-cart-checkout-button", function () {
            $(this).addClass("disable");
        });
    },
    passwordStrength: function () {
        $('.password-strength').pstrength({
            verdicts: [ACC.pwdStrengthTooShortPwd,
                ACC.pwdStrengthVeryWeak,
                ACC.pwdStrengthWeak,
                ACC.pwdStrengthMedium,
                ACC.pwdStrengthStrong,
                ACC.pwdStrengthVeryStrong],
            minCharText: ACC.pwdStrengthMinCharText,
            minPass: 8,
            minchar: 1
        });
    },

    bindToggleOffcanvas: function () {
        $(window).on('resize', function () {
            $.colorbox.resize();

            setTimeout(function(){
              if($('.js_navigation--bottom').is(':visible')) {
                if($(window).width() < 1024) {
                  if(!$('html,body').hasClass('overflowHidden'))
                    $('html,body').addClass('overflowHidden');
                } else {
                  $('html,body').removeClass('overflowHidden');
                }
              } else {
                if($('html,body').hasClass('overflowHidden'))
                  $('html,body').removeClass('overflowHidden');
              }
            }, 100);
        });

        $(document).on("click", ".js-toggle-sm-navigation", function () {
            $('.js_navigation--bottom').fadeToggle(200);
            setTimeout(function() {
                if($('.js_navigation--bottom').attr('style') == 'display: none;') {
                    $('.js_navigation--bottom').removeAttr('style');
                }
            }, 400);

            setTimeout(function(){
              if($('.js_navigation--bottom').is(':visible')) {
                if(!$('html,body').hasClass('overflowHidden'))
                  $('html,body').addClass('overflowHidden');
              } else {
                if($('html,body').hasClass('overflowHidden'))
                  $('html,body').removeClass('overflowHidden');
              }
            }, 410);
            /* Contentsquare */
                ACC.track.contentsquareAPVTracking("mobile-menu");
            /* Contentsquare */
        });
    },

    closeMenuOnClickOut: function () {
        $(document).on("click", ".js_navigation--bottom", function (e) {
            if($(e.target).hasClass('js_navigation--bottom')) {
                $('.js_navigation--bottom').fadeOut(200);
                setTimeout(function() {
                    $('.js_navigation--bottom').removeAttr('style');
                }, 400);
                $('body').removeClass('overflowHidden');
            }
        });

        $(window).on("resize", function (e) {
        	$('body').removeClass('overflowHidden');

        	if($(window).width() > 1023) {
        	    ACC.colorbox.close();
        	}
        });
    },

    viewHomePageBanner: function (){
        if ($(".page-homepage .home-page__banner").length > 0) {
            var bannerName = $('.page-homepage .home-page__banner').data('banner-name');
            ACC.track.homeBannerViewEvent(bannerName);
        }
    },



    trackPlpClick : function(){
        $(document).on('click', '.product__list--name', function(e) {
            localStorage.setItem("plpClickIndex",$('.product__list li').toArray().indexOf($(this).closest('li')[0]));
        });
        $(document).on('click', '.addtocart', function(e) {
            localStorage.setItem("plpClickIndex",$('.product__list li').toArray().indexOf($(this).closest('li')[0]));
        });
    },

    selectAganecyEvent : function (){
        $(document).on('click' ,'.choose_agency', function(){
            var pointOfServiceName = $(this).closest('#saveAgencyForm').find('#pointOfServiceName').val();
            var pointOfServiceDisplayName = $(this).closest('#saveAgencyForm').find('#pointOfServiceDisplayName').val();

            if(pointOfServiceName == undefined && pointOfServiceDisplayName == undefined){
                pointOfServiceName = $('input[name=popinStoreNamePost]:checked').val();
                pointOfServiceDisplayName = $('input[name=popinStoreNamePost]:checked').attr("data-display-Name");
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event':'select_agency',
                'agency_id': pointOfServiceName ,
                'agency_name': pointOfServiceDisplayName
            });

        });


    },


    bindToggleXsSearch: function () {
        $(document).on("click", ".js-toggle-xs-search", function () {
            ACC.global.toggleClassState($(".site-search-mobile"), "active");
            $(".site-search-mobile input[type=text]").focus();
            ACC.global.toggleClassState($(".js-mainHeader .navigation--middle"), "search-open");
        });
    },

    resetXsSearch: function () {
        $('.site-search').removeClass('active');
        $(".js-mainHeader .navigation--middle").removeClass("search-open");
    },

    toggleClassState: function ($e, c) {
        $e.hasClass(c) ? $e.removeClass(c) : $e.addClass(c);
        return $e.hasClass(c);
    },

    submitFormsGA : function(){
        $('.GATrackForm').on('submit',function (e){
            var formId = $(this).closest('form').attr('id');
            var formName = $(this).closest('form').attr('name');
            ACC.track.trackForms(formName,formId);
        })
    },

    toggleCheckbox: function () {
        $("[id^=certificatCheckBox]").on("change", function () {
            var $_self = $(this);

            if($_self.is(':checked')) {
                $_self.parent().find('.inputCheckbox').addClass("checked");
            } else {
                $_self.parent().find('.inputCheckbox').removeClass("checked");
            }
        });
    },

    testCheck : function(){
        if($("[id^=certificatCheckBox]").length){
            var checkbox = $("[id^=certificatCheckBox]");
            if(checkbox.is(':checked')) {
                checkbox.parent().find('.inputCheckbox').addClass("checked");
            } else {
                checkbox.parent().find('.inputCheckbox').removeClass("checked");
            }
        }
    },

    bindHoverIntentMainNavigation: function () {

        enquire.register("screen and (min-width:" + screenMdMin + ")", {

            match: function () {
                // on screens larger or equal screenMdMin (1024px) calculate position for .sub-navigation
                $(".js-enquire-has-sub").hoverIntent(function () {
                    var $this = $(this),
                        itemWidth = $this.width();
                    var $subNav = $this.find('.js_sub__navigation'),
                        subNavWidth = $subNav.outerWidth();
                    var $mainNav = $('.js_navigation--bottom'),
                        mainNavWidth = $mainNav.width();

                    // get the left position for sub-navigation to be centered under each <li>
                    var leftPos = $this.position().left + itemWidth / 2 - subNavWidth / 2;
                    // get the top position for sub-navigation. this is usually the height of the <li> unless there is more than one row of <li>
                    var topPos = $this.position().top + $this.height();

                    if (leftPos > 0 && leftPos + subNavWidth < mainNavWidth) {
                        // .sub-navigation is within bounds of the .main-navigation
                        $subNav.css({
                            "left": leftPos,
                            "top": topPos,
                            "right": "auto"
                        });
                    } else if (leftPos < 0) {
                        // .suv-navigation can't be centered under the <li> because it would exceed the .main-navigation on the left side
                        $subNav.css({
                            "left": 0,
                            "top": topPos,
                            "right": "auto"
                        });
                    } else if (leftPos + subNavWidth > mainNavWidth) {
                        // .suv-navigation can't be centered under the <li> because it would exceed the .main-navigation on the right side
                        $subNav.css({
                            "right": 0,
                            "top": topPos,
                            "left": "auto"
                        });
                    }
                    $this.addClass("show-sub");
                }, function () {
                    $(this).removeClass("show-sub")
                });
            },

            unmatch: function () {
                // on screens smaller than screenMdMin (1024px) remove inline styles from .sub-navigation and remove hoverIntent
                $(".js_sub__navigation").removeAttr("style");
                $(".js-enquire-has-sub").hoverIntent(function () {
                    // unbinding hover
                });
            }

        });
    },

    initImager: function (elems) {
        elems = elems || '.js-responsive-image';
        this.imgr = new Imager(elems);
    },

    reprocessImages: function (elems) {
        elems = elems || '.js-responsive-image';
        if (this.imgr == undefined) {
            this.initImager(elems);
        } else {
            this.imgr.checkImagesNeedReplacing($(elems));
        }
    },

    backToHome: function () {
        $(".backToHome").on("click", function () {
            var sUrl = ACC.config.contextPath;
            window.location = sUrl;
        });
    },

    viewHomePageBanner: function (){
        if ($(".page-homepage .banner__component--responsive").length > 0) {
            var bannerName = $('.page-homepage .home-page__banner').data('banner-name');
            ACC.track.homeBannerViewEvent(bannerName);
        }
    },

    clickHomePageBanner: function(){
        $(document).on('click', '.page-homepage .home-page__banner a', function () {
            var bannerName = $('.page-homepage .home-page__banner').data('banner-name');
            ACC.track.homeBannerClickEvent(bannerName);
        });
    },

    myaccountContactBtnTel: function () {
        var btnTel = $(".myaccount-contact-btn-tel");
        $(window).on('load resize', function () {
            if($(window).width() > 1024) {
                btnTel.on("mouseenter", function () {
                    $(this).html($(this).data('tel'));
                }).on("mouseleave", function () {
                    $(this).html($(this).data('title'));
                });
                btnTel.attr('href', "#");
            } else {
                btnTel.attr('href', "tel:"+btnTel.data('tel'));
            }
        })
    },

    myaccountContactBtnEmail: function () {
        var btnEmail = $(".myaccount-contact-btn-email");

        $(window).on('load resize', function () {
            if($(window).width() > 1024) {
                btnEmail.on("mouseenter", function () {
                    $(this).html($(this).data('email')).css({'font-size': '16px', 'font-weight': 'bold'});
                }).on("mouseleave", function () {
                    $(this).html($(this).data('title')).removeAttr('style');
                });
            }
        })
    },

    myaccountWysDeleteEmptyP: function(){
        var paragraphe = $('.myaccountpage__bloc--content');

        if(paragraphe.length){
            paragraphe.each(function(i, el){
                $(el).find('p').each(function(i, el){
                    if( $(el).is(':empty') || ( !$(el).text().length && $(el).find('br') )){
                        $(el).remove();
                    }
                });
            });
        }
    },

    changeProfileDivOrder: function () {
        $('.page-update-profile .account-section-content > div + div').insertAfter('.page-update-profile .account-section-content > div + div +');
        $('.page-update-profile .account-section-content > div').css('opacity', '1');
    },

    openCompletionPopin: function() {
        $('.completionRequest').on('click', function(e) {
            e.preventDefault();

            $.colorbox({
                href: "#ct-completionRequest",
                maxWidth: "100%",
                width: 525,
                opacity: 0.7,
                inline: true,
                title: $('#ct-completionRequest-title').html(),
                close: '<span class="glyphicon glyphicon-remove"></span>',
                onOpen: function() {
                    $('#ct-completionRequest').show();
                },
                onComplete: function() {

                	 $('input[name=phone]').bind('keypress', function(e) {
                		 //ACC.register.checkInputNumberType([this]);
                	 });
                },
                onCleanup: function() {
                    $('#ct-completionRequest').hide();
                }
            });
        })
    },
    openLoyaltyUnsubscribePopin: function() {
	if(user.userLoyaltyStatus == 1)
	{
		    $('.openLoyaltyUnsubscribePopin').removeClass("hidden");
		    $('.openLoyaltyUnsubscribePopin').on('click', function(e) {
            e.preventDefault();

            $.colorbox({
                href: "#loyaltyUnsubscribePopin",
                maxWidth: "100%",
                width: 480,
                opacity: 0.7,
                inline: true,
                close: '<span class="glyphicon glyphicon-remove"></span>',
                onOpen: function() {
                    $('#loyaltyUnsubscribePopin').show();
                    $("#cboxContent").addClass("loyaltyUnsubscribePopin");
                },
                onCleanup: function() {
                    $('#loyaltyUnsubscribePopin').hide();
                }
            });
        });
        $(document).on('click', '.btn-loyaltyCancel-js',
            function(e) {
                e.preventDefault();
                ACC.colorbox.close();
            }
        );
		$(document).on('click', '.btn-loyaltyUnsubscribe-js',
            function(e) {
				$.ajax({
					url: ACC.config.encodedContextPath + "/loyalty/unsubscribe",
					type: "POST",
					success: function(response){
						if(response)
						{
							$('.loyaltyUnsubscribeTitle-js').addClass("hidden");
							$('.loyaltyUnsubscribedTitle-js').removeClass("hidden");
							$('.btn-loyaltyCancel-js').addClass("hidden");
							$('.btn-loyaltyUnsubscribe-js').addClass("hidden");
							$('.openLoyaltyUnsubscribePopin').addClass("hidden");
							setTimeout(function() {ACC.colorbox.close()}, 3000);
						}
						else
						{
							ACC.colorbox.close();
						}
					}
				});

            }
        );
	}

    },

	openRgpdRequestPopin: function() {
        $('.rgpdRequest').on('click', function(e) {
            e.preventDefault();

            $.colorbox({
                href: "#ct-rgpdRequest",
                maxWidth: "100%",
                width: 525,
                opacity: 0.7,
                inline: true,
                title: $('#ct-rgpdRequest-title').html(),
                close: '<span class="glyphicon glyphicon-remove"></span>',
                onOpen: function() {
                    $('#ct-rgpdRequest').show();
                },
                onComplete: function() {

                },
                onCleanup: function() {
                    $('#ct-rgpdRequest').hide();
                }
            });
        })
    },

    alterPassInfo: function () {
        $('#password_bar').insertAfter('.pass-info');
    },

	showIfConnected: function () {
		if ($(".connected-menu")[0]){
			$( ".showIfConnected" ).show();
		}

	},

    mySelect: function () {
        $(document).ready(function() {
            $('.mySelect').customSelect({
                multiple: false,
                onChange: function(selected) {
                    console.log('Options sélectionnées : ', selected);
                }
            });
        });

    }

};
